import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { DataList } from "../types";

export function PdfPaymentTermVendor(props: { dataList: DataList[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    {
      header: "PAYMENT TERM VENDOR",
      key: "payment_term_vendor",
      width: 10,
    },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.payment_term_vendor_code ?? "-",
    payment_term_vendor: item.payment_term_vendor_name
      ? `${item.payment_term_vendor_name} Day`
      : "-",
    description: item.description ?? "-",
  }));

  return (
    <PdfTemplate data={dataMap} column={columns} title="Payment Term Vendor" />
  );
}
